<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
      <div
        class="collapse-btn ion-hide-md-down"
        (click)="sideMenuService.toggleSidebar()"
      >
        <ion-icon name="menu-outline"></ion-icon>
      </div>
      <app-breadcrumb></app-breadcrumb>
    </ion-buttons>
    <div class="all-right" slot="end">
      <div class="flex">
        <ng-container *ngIf="canShowViewToggle">
          <ion-icon
            [name]="viewToggleIcon"
            [title]="viewToggleTitle"
            (click)="viewToggleClicked()"
          ></ion-icon>
        </ng-container>
        <ng-container *ngIf="canShowRefresh">
          <ion-icon
            name="refresh-outline"
            (click)="refreshClicked()"
          ></ion-icon>
        </ng-container>
        <ng-container *ngIf="canShowChartSettingIcon">
          <ion-icon
            name="settings-outline"
            (click)="openChartViewSettingModal()"
          ></ion-icon>
        </ng-container>
        <ng-container *ngIf="canShowRefreshGraph">
          <ion-icon
            name="filter-outline"
            (click)="openFilterGraphModal()"
          ></ion-icon>
        </ng-container>
        <ng-container *ngIf="canShowPrintAndEmail">
          <ion-icon
            name="print-outline"
            (click)="openPrint()"
            *ngxPermissionsOnly="['print_customer_orders_sales_operations_customer_orders']"
          ></ion-icon>
        </ng-container>
        <ng-container *ngIf="canShowManageHelp">
          <ion-icon
            name="help-buoy-outline"
            (click)="openManageHelp()"
            *ngxPermissionsOnly="[
              'view_help_manage_help',
              'view_help_manage_help_help_categories',
              'view_help_manage_help_help_posts'
            ]"
          ></ion-icon>
        </ng-container>
        <ion-icon
          *ngxPermissionsOnly="[
            'view_quick_search_search_customers',
            'view_quick_search_search_products'
          ]"
          name="search-outline"
          [routerLink]="ROUTES.QUICK_SEARCH_PAGE"
        ></ion-icon>
        <ng-container *ngIf="!isMobile">
          <ion-icon
            name="expand-outline"
            *ngIf="elem && elem.requestFullscreen && !fullScreen"
            (click)="openFullscreen()"
          ></ion-icon>
          <ion-icon
            name="contract-outline"
            *ngIf="elem && elem.requestFullscreen && fullScreen"
            (click)="closeFullscreen()"
          ></ion-icon>
        </ng-container>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
